






















































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import ProjectDirectives from '@/domain/directives/project-directives.entity';
import DirectiveDefinition from '../../domain/directives/directive-definition.entity';

@Component
export default class DirectivesWorkItemTypeCard extends Vue {
  @Prop()
  projectWorkItemTypesDirectives!: ProjectDirectives[];

  @Prop()
  selectedWorkItemTypeDirectives!: DirectiveDefinition[];

  @Prop()
  allWorkItemTypes!: DirectiveDefinition[];

  @Prop()
  loading!: boolean;

  @Emit('selectWorkItemType')
  private selectWorkItemType(obj: any) {
    return obj;
  }

  private isSelectedWorkItemType(workItemType: any) {
    return workItemType === this.selectedWorkItemTypeDirectives;
  }

  private get isTheWorkItemTypeListBigEnough() {
    return this.projectWorkItemTypesDirectives.length > 7;
  }

  private get allWorkItemTypesI18nUpperCasedString() {
    const string: any = this.$t('allWorkItemTypes');
    return string.toUpperCase();
  }
}
